import { complex, rwAttrib } from '../schema-engine';
import { getOptionalReal, setOptionalReal, setOptionalRealRange } from './real.actions';

export function score() {
  return complex({
    raw: rwAttrib(getOptionalReal, setOptionalReal, 'raw'),
    min: rwAttrib(getOptionalReal, setOptionalReal, 'min'),
    max: rwAttrib(getOptionalReal, setOptionalReal, 'max'),
    scaled: rwAttrib(getOptionalReal, setOptionalRealRange(-1, 1), 'scaled')
  });
}
